'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Binder$() {
}
export { $c_Lcom_raquo_laminar_modifiers_Binder$ as $c_Lcom_raquo_laminar_modifiers_Binder$ };
$p = $c_Lcom_raquo_laminar_modifiers_Binder$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Binder$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Binder$() {
}
export { $h_Lcom_raquo_laminar_modifiers_Binder$ as $h_Lcom_raquo_laminar_modifiers_Binder$ };
$h_Lcom_raquo_laminar_modifiers_Binder$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_Binder$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_Binder$, "com.raquo.laminar.modifiers.Binder$", ({
  iq: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Binder$ as $d_Lcom_raquo_laminar_modifiers_Binder$ };
var $n_Lcom_raquo_laminar_modifiers_Binder$;
function $m_Lcom_raquo_laminar_modifiers_Binder$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_Binder$)) {
    $n_Lcom_raquo_laminar_modifiers_Binder$ = new $c_Lcom_raquo_laminar_modifiers_Binder$();
  }
  return $n_Lcom_raquo_laminar_modifiers_Binder$;
}
export { $m_Lcom_raquo_laminar_modifiers_Binder$ as $m_Lcom_raquo_laminar_modifiers_Binder$ };
